export default {
  title: {
    en: 'Activate your account',
  },
  text: {
    en: `
      Unfortunately, only subscribers have exclusive access to all fragrance,
      makeup and skincare products.
    `,
  },
  subscribeButton: {
    en: 'Subscribe now',
  },
  resubscribeButton: {
    en: 'Resubscribe',
  },
  footerText: {
    en: 'No, I do not want to save money and try awesome beauty products',
  },
}
